import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'dev.rpgbooking.app',
  appName: 'RPG Booking',
  webDir: 'dist',
  bundledWebRuntime: false
};

export default config;
